{
  "addons.addonList": "Liste des services tiers",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Créer et récupérer votre clé d'API depuis ce lien",
  "addons.ambientWeatherDescription": "Stations météo Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Clé d'API",
  "addons.applicationKey": "Clé d'application",
  "addons.connect": "Se connecter",
  "addons.davisApiSecret": "API Secret",
  "addons.davisApiV2Key": "Clé API V2",
  "addons.davisDescription": "Stations météo Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Récupérer vos clés d'API V2 depuis ce lien",
  "addons.disconnect": "Se déconnecter",
  "addons.ecowittCreateAndRetrieveKeys": "Créer et récupérer votre clé d'API et votre clé d'application depuis ce lien",
  "addons.ecowittDescription": "Ecowitt fournit des stations météo professionnelles, des thermomètres intérieurs/extérieurs sans fil, des pluviomètres de hautes précisions, des capteurs de qualité de l'air et bien plus encore.",
  "addons.helpLink": "Comment connecter {provider}",
  "addons.myAcuriteAccountOnHold": "La connexion à votre compte est impossible. Veuillez saisir votre mot de passe pour reconnecter votre compte",
  "addons.myAcuriteDescription": "AcuRite est la marque de stations météorologiques n°1 en Amérique du Nord. En tant que leader en technologie de temps, de température et de météo, AcuRite vous fournit des informations détaillées sur votre environnement intérieur et extérieur afin que vous puissiez planifier votre journée en toute confiance.",
  "addons.myAcuriteEnterCredentials": "Entrez vos identifiants My AcuRite afin de lier votre compte My AcuRite à SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Utilisez votre thermostat Netatmo pour changer la température de votre maison, depuis votre lit ou depuis l'autre bout du monde.",
  "addons.netatmoThermostat": "Netatmo Thermostat",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Vos propres mesures météo sur votre smartphone.",
  "addons.or": "ou",
  "addons.providerAccountDisconnected": "La connexion à votre service météo a expiré. Veuillez vous reconnecter pour reprendre les mises à jour.",
  "addons.reconnect": "Reconnecter",
  "addons.weatherflowCreateToken": "Créer et récupérer votre token depuis ce lien",
  "addons.weatherflowTempestDescription": "Station météo Tempest dévelopée par Weatherflow",
  "addons.wundergroundApiKey": "Clé d'API",
  "addons.wundergroundDescription": "Weather Underground est une communauté mondiale de personnes connectant les données de capteurs environnementaux tels que les stations météorologiques et les moniteurs de qualité de l'air afin que nous puissions fournir les données riches et hyperlocales dont vous avez besoin pour alimenter vos passions.",
  "addons.wundergroundRetrieveApiKey": "Récupérer votre clé d'API depuis ce lien",
  "addons.wundergroundRetrieveStationId": "Récupérer votre identifiant de station (ID) depuis ce lien",
  "addons.wundergroundStationId": "Identifiant de la station",
  "airQuality.airQuality": "Qualité de l'air",
  "airQuality.airQualityIndex": "Indice de qualité de l'air",
  "airQuality.aqiForecast": "Prévisions de qualité de l'air",
  "airQuality.co": "Monoxyde de carbone",
  "airQuality.dailyForecast": "Prévisions quotidiennes",
  "airQuality.details": "Détails",
  "airQuality.dominantPollutant": "Polluant dominant",
  "airQuality.good": "Bon",
  "airQuality.goodDescription": "La qualité de l'air est jugée satisfaisante, et la pollution de l'air pose peu ou pas de risque.",
  "airQuality.hazardous": "Dangereux",
  "airQuality.hazardousDescription": "Alerte de santé : tout le monde peut ressentir des effets de santé plus graves.",
  "airQuality.indoorAirQuality": "Qualité de l'air intérieur",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Modéré",
  "airQuality.moderateDescription": "La qualité de l'air est acceptable. Cependant, pour certains polluants, il peut y avoir un risque sur la santé pour un très petit nombre de personnes inhabituellement sensibles à la pollution atmosphérique.",
  "airQuality.no2": "Dioxyde d'azote",
  "airQuality.o3": "Ozone",
  "airQuality.pm10": "Particules inférieures à 10μm",
  "airQuality.pm25": "Particules inférieures à 2.5μm",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Mauvais pour les groupes sensibles",
  "airQuality.sensitiveUnhealthyDescription": "Les membres des groupes sensibles peuvent ressentir des effets sur la santé. Le grand public ne devrait pas être affecté.",
  "airQuality.so2": "Dioxyde de soufre",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Mauvais",
  "airQuality.unhealthyDescription": "Tout le monde peut commencer à ressentir des effets sur la santé ; les membres des groupes sensibles peuvent ressentir des effets de santé plus graves.",
  "airQuality.veryUnhealthy": "Très mauvais",
  "airQuality.veryUnhealthyDezscription": "Avertissements de santé de conditions d'urgence. Toute la population est plus susceptible d'être affecté.",
  "alerts.addAlert": "Ajouter une alerte",
  "alerts.addCondition": "Ajouter une condition",
  "alerts.alertAdded": "Alerte ajoutée avec succès",
  "alerts.alertAuthorizationNotice": "Les alertes ne peuvent fonctionner seulement si vous autorisez SmartMixin à afficher les notifications",
  "alerts.alertDeleted": "Alerte supprimée avec succès",
  "alerts.alertEdited": "Alerte modifiée avec succès",
  "alerts.alertName": "Nom de l'alerte",
  "alerts.alertWhen": "Je souhaite être alerté·e",
  "alerts.aqiGreaterThan": "AQI supérieur à",
  "alerts.aqiGreaterThanThreshold": "AQI supérieur au seuil de {value}{unit}",
  "alerts.aqiLessThan": "AQI inférieur à",
  "alerts.aqiLessThanThreshold": "AQI inférieur au seuil de {value}{unit}",
  "alerts.atLeastOneCondition": "Vous devez ajouter au moins une condition",
  "alerts.co2GreaterThan": "CO2 supérieur à",
  "alerts.co2GreaterThanThreshold": "CO2 supérieur au seuil de {value}{unit}",
  "alerts.co2LessThan": "CO2 inférieur à",
  "alerts.co2LessThanThreshold": "CO2 inférieur au seuil de {value}{unit}",
  "alerts.conditions": "Conditions",
  "alerts.createAlert": "Créer l'alerte",
  "alerts.dailyPrecipitationGreaterThan": "Précipitations journalières supérieures à",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Précipitations journalières supérieures au seuil de {value}{unit}",
  "alerts.deleteAlert": "Supprimer l'alerte",
  "alerts.editAlert": "Modifier l'alerte",
  "alerts.editCondition": "Modifier la condition",
  "alerts.gustSpeedGreaterThan": "Rafale supérieure à",
  "alerts.gustSpeedGreaterThanThreshold": "Rafale supérieure au seuil de {value}{unit}",
  "alerts.gustSpeedLessThan": "Rafale inférieure à",
  "alerts.gustSpeedLessThanThreshold": "Rafale inférieure au seuil de {value}{unit}",
  "alerts.heatIndexGreaterThan": "Indice de chaleur supérieur à",
  "alerts.heatIndexGreaterThanThreshold": "Indice de chaleur supérieur au seuil de {value}{unit}",
  "alerts.heatIndexLessThan": "Indice de chaleur inférieur à",
  "alerts.heatIndexLessThanThreshold": "Indice de chaleur inférieur au seuil de {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex supérieur à",
  "alerts.humidexGreaterThanThreshold": "Humidex supérieur au seuil de {value}{unit}",
  "alerts.humidexLessThan": "Humidex inférieur à",
  "alerts.humidexLessThanThreshold": "Humidex inférieur au seuil de {value}{unit}",
  "alerts.humidityGreaterThan": "Humidité supérieure à",
  "alerts.humidityGreaterThanThreshold": "Humidité supérieure au seuil de {value}{unit}",
  "alerts.humidityLessThan": "Humidité inférieure à",
  "alerts.humidityLessThanThreshold": "Humidité inférieure au seuil de {value}{unit}",
  "alerts.inProgress": "En cours",
  "alerts.myAlerts": "Mes alertes",
  "alerts.noConfiguredAlert": "Vous n'avez pas encore d'alerte, ajoutez-en une",
  "alerts.noiseGreaterThan": "Bruit supérieur à",
  "alerts.noiseGreaterThanThreshold": "Bruit supérieur au seuil de {value}{unit}",
  "alerts.noiseLessThan": "Bruit inférieur à",
  "alerts.noiseLessThanThreshold": "Bruit inférieur au seuil de {value}{unit}",
  "alerts.noteOnConditions": "Notez que l'alerte est déclenchée lorsque toutes les conditions ci-dessous sont vérifiées",
  "alerts.pm10GreaterThan": "PM 10 supérieur à",
  "alerts.pm10GreaterThanThreshold": "PM 10 supérieur au seuil de {value}{unit}",
  "alerts.pm10LessThan": "PM 10 inférieur à",
  "alerts.pm10LessThanThreshold": "PM 10 inférieur au seuil de {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 supérieur à",
  "alerts.pm1GreaterThanThreshold": "PM 1 supérieur au seuil de {value}{unit}",
  "alerts.pm1LessThan": "PM 1 inférieur à",
  "alerts.pm1LessThanThreshold": "PM 1 inférieur au seuil de {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 supérieur à",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 supérieur au seuil de {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 inférieur à",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 inférieur au seuil de {value}{unit}",
  "alerts.postStormSummary": "Résumé de l'épisode pluvieux",
  "alerts.postStormSynopsisHelper": "Vous recevrez une notification récapitulative à la fin de chaque épisode pluvieux.",
  "alerts.postStormSynopsisSoleCondition": "Un récapitulatif post-tempête ne peut pas être combiné avec d'autres conditions.",
  "alerts.precipitationGreaterThan": "Précipitations horaires supérieures à",
  "alerts.precipitationGreaterThanThreshold": "Précipitations horaires supérieures au seuil de {value}{unit}",
  "alerts.pressureGreaterThan": "Pression supérieure à",
  "alerts.pressureGreaterThanThreshold": "Pression supérieure au seuil de {value}{unit}",
  "alerts.pressureLessThan": "Pression inférieure à",
  "alerts.pressureLessThanThreshold": "Pression inférieure au seuil de {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensité de pluie supérieure à",
  "alerts.rainRateGreaterThanThreshold": "Intensité de pluie supérieure au seuil de {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Rayonnement solaire supérieur à",
  "alerts.solarRadiationGreaterThanThreshold": "Rayonnement solaire supérieur au seuil de {value}{unit}",
  "alerts.solarRadiationLessThan": "Rayonnement solaire inférieur à",
  "alerts.solarRadiationLessThanThreshold": "Rayonnement solaire inférieur au seuil de {value}{unit}",
  "alerts.temperatureGreaterThan": "Température supérieure à",
  "alerts.temperatureGreaterThanThreshold": "Température supérieure au seuil de {value}{unit}",
  "alerts.temperatureLessThan": "Température inférieure à",
  "alerts.temperatureLessThanThreshold": "Température inférieure au seuil de {value}{unit}",
  "alerts.thswGreaterThan": "THSW supérieur à",
  "alerts.thswGreaterThanThreshold": "THSW supérieur au seuil de {value}{unit}",
  "alerts.thswLessThan": "THSW inférieur à",
  "alerts.thswLessThanThreshold": "THSW inférieur au seuil de {value}{unit}",
  "alerts.thwGreaterThan": "THW supérieur à",
  "alerts.thwGreaterThanThreshold": "THW supérieur au seuil de {value}{unit}",
  "alerts.thwLessThan": "THW inférieur à",
  "alerts.thwLessThanThreshold": "THW inférieur au seuil de {value}{unit}",
  "alerts.uvGreaterThan": "UV supérieur à",
  "alerts.uvGreaterThanThreshold": "UV supérieur au seuil de {value}{unit}",
  "alerts.uvLessThan": "UV inférieur à",
  "alerts.uvLessThanThreshold": "UV inférieur au seuil de {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilité supérieure au seuil de {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilité inférieure au seuil de {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilité supérieure à",
  "alerts.visiblityLessThan": "Visibilité inférieure à",
  "alerts.whichMeasure": "Pour quelle mesure souhaitez-vous être alerté·e ?",
  "alerts.whichModule": "Pour quel module souhaitez-vous être alerté·e ?",
  "alerts.windChillGreaterThan": "Refroidissement éolien supérieur à",
  "alerts.windChillGreaterThanThreshold": "Refroidissement éolien supérieur au seuil de {value}{unit}",
  "alerts.windChillLessThan": "Refroidissement éolien inférieur à",
  "alerts.windChillLessThanThreshold": "Refroidissement éolien inférieur au seuil de {value}{unit}",
  "alerts.windSpeedGreaterThan": "Vent supérieur à",
  "alerts.windSpeedGreaterThanThreshold": "Vent supérieur au seuil de {value}{unit}",
  "alerts.windSpeedLessThan": "Vent inférieur à",
  "alerts.windSpeedLessThanThreshold": "Vent inférieur au seuil de {value}{unit}",
  "astral.astronomicalSunPhase": "{sunPhase} astronomique",
  "astral.civilSunPhase": "{sunPhase} civil",
  "astral.dawn": "Aube",
  "astral.dusk": "Crépuscule",
  "astral.firstQuarter": "Premier quartier",
  "astral.fullMoon": "Pleine Lune",
  "astral.lastQuarter": "Dernier quartier",
  "astral.moon": "Lune",
  "astral.moonPhases": "Phases de la Lune",
  "astral.moonrise": "Lever de Lune",
  "astral.moonset": "Coucher de Lune",
  "astral.nauticalSunPhase": "{sunPhase} nautique",
  "astral.newMoon": "Nouvelle Lune",
  "astral.noon": "Midi",
  "astral.remainingDaylight": "Lumière du jour restante",
  "astral.sunrise": "Lever du Soleil",
  "astral.sunriseAndSunset": "Lever et coucher du Soleil",
  "astral.sunriseAt": "Lever du soleil à {time}",
  "astral.sunset": "Coucher du Soleil",
  "astral.sunsetAt": "Coucher du soleil à {time}",
  "astral.totalDaylight": "Lumière du jour totale",
  "astral.waningCrescent": "Dernier croissant",
  "astral.waningGibbous": "Lune gibbeuse décroissante",
  "astral.waxingCrescent": "Premier croissant",
  "astral.waxingGibbous": "Lune gibbeuse croissante",
  "auth.alreadyHaveAccount": "Vous avez déjà un compte ?",
  "auth.authContainerTagline": "Votre tableau de bord météo personnel. Connectez vos stations et accédez à vos données en temps réel.",
  "auth.backToLogin": "Retour à la connexion",
  "auth.catchPhrase": "The Weather Intelligence Platform",
  "auth.checkYourEmail": "Vérifiez votre e-mail",
  "auth.continueWithApple": "Continuer avec Apple",
  "auth.continueWithFacebook": "Continuer avec Facebook",
  "auth.continueWithGoogle": "Continuer avec Google",
  "auth.email": "Adresse e-mail",
  "auth.emailRequiredLoginFacebook": "La permission e-mail est nécessaire pour se connecter avec Facebook",
  "auth.emailVerification": "Vérification de l'e-mail",
  "auth.emailVerificationFailure": "Nous avons rencontré un problème lors de la vérification de votre email.",
  "auth.emailVerificationSuccess": "Votre e-mail a été vérifié avec succès.",
  "auth.firstName": "Prénom",
  "auth.forgotPassword": "Mot de passe oublié",
  "auth.forgotPasswordSubtitle": "Entrez votre e-mail et nous vous enverrons un lien pour réinitialiser votre mot de passe.",
  "auth.lastName": "Nom",
  "auth.login": "Se connecter",
  "auth.loginSubtitle": "Content de vous revoir ! Veuillez entrer vos identifiants.",
  "auth.loginToSmartMixinDescription": "Entrez vos informations d'identification SmartMixin pour accéder à votre compte.",
  "auth.logout": "Se déconnecter",
  "auth.logoutConfirmation": "Êtes-vous sûr de vouloir vous déconnecter ?",
  "auth.noAccountYet": "Vous n'avez pas encore de compte ?",
  "auth.or": "ou",
  "auth.password": "Mot de passe",
  "auth.passwordAgain": "Confirmer le mot de passe",
  "auth.passwordReset": "Réinitialisation du mot de passe",
  "auth.passwordResetSuccess": "Mot de passe réinitialisé avec succès.",
  "auth.register": "Inscription",
  "auth.registerDescription": "Créez un compte SmartMixin gratuit pour connecter vos stations météo, suivre les données météorologiques et accéder à de puissants outils d’analyse.",
  "auth.registerSubtitle": "Créez votre compte pour commencer.",
  "auth.registerSuccess": "Vous vous êtes inscrit avec succès ! Nous venons de vous envoyer un lien de vérification à l'adresse {emailAddress} avec des instructions supplémentaires.",
  "auth.restorePassword": "Restaurer le mot de passe",
  "auth.restorePasswordSuccess": "Nous venons de vous envoyer un lien de réinitialisation de mot de passe à l'adresse {emailAddress} avec des instructions supplémentaires.",
  "auth.sendReset": "Envoyer les instructions de réinitialisation",
  "auth.socialAccount": "ou utilisez votre compte",
  "auth.welcome": "Bienvenue sur SmartMixin",
  "auth.welcomeBack": "Re-bonjour !",
  "calendar.april": "Avril",
  "calendar.august": "Août",
  "calendar.dateFormat": "Format de date",
  "calendar.day": "Jour",
  "calendar.december": "Décembre",
  "calendar.end": "Fin",
  "calendar.february": "Février",
  "calendar.hours": "heures",
  "calendar.hoursShort": "h",
  "calendar.january": "Janvier",
  "calendar.july": "Juillet",
  "calendar.june": "Juin",
  "calendar.last24Hours": "24 dernières heures",
  "calendar.last30Days": "30 derniers jours",
  "calendar.last7Days": "7 derniers jours",
  "calendar.march": "Mars",
  "calendar.max": "Max",
  "calendar.may": "Mai",
  "calendar.month": "Mois",
  "calendar.months": "mois",
  "calendar.november": "Novembre",
  "calendar.october": "Octobre",
  "calendar.oneDay": "1 jour",
  "calendar.oneHour": "1 heure",
  "calendar.oneMonth": "1 mois",
  "calendar.oneWeek": "1 semaine",
  "calendar.previous24Hours": "Les 24 heures précédentes",
  "calendar.previous30Days": "Les 30 jours précédents",
  "calendar.previous7Days": "Les 7 jours précédents",
  "calendar.previousDay": "Jour précédent",
  "calendar.previousMonth": "Mois précédent",
  "calendar.previousWeek": "Semaine précédente",
  "calendar.previousYear": "Année précédente",
  "calendar.sameDayLastYear": "Même jour l'année dernière",
  "calendar.sameMonthLastYear": "Même mois l'année dernière",
  "calendar.selectADate": "Sélectionnez une date",
  "calendar.selectAggregation": "Choisir la valeur affichée",
  "calendar.selectAMonth": "Sélectionnez un mois",
  "calendar.selectAYear": "Sélectionnez une année",
  "calendar.selectGranularity": "Granularité des mesures",
  "calendar.selectTimescale": "Échelle de temps",
  "calendar.september": "Septembre",
  "calendar.sixHours": "6 heures",
  "calendar.start": "Début",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 heures",
  "calendar.use24HourFormat": "Utiliser le format 24h",
  "calendar.week": "Semaine",
  "calendar.year": "Année",
  "calendar.yesterday": "Hier",
  "common.accountDeleted": "Votre compte a été supprimé avec succès.",
  "common.accountOnHold": "La connexion de votre compte a expiré. Veuillez vous reconnecter pour reprendre les mises à jour.",
  "common.add": "Ajouter",
  "common.addAStation": "Ajouter une station",
  "common.addToFavorites": "Ajouter aux favoris",
  "common.addYourOwnStation": "Ajoutez votre station",
  "common.alreadyPremium": "Vous avez déjà un compte premium !",
  "common.alsoAvailableOn": "Également disponible sur :",
  "common.altitude": "Altitude",
  "common.analysis": "Analyses",
  "common.aroundMe": "Autour de moi",
  "common.articleCount": "{count, plural, one {# article} other {# articles}}",
  "common.articleNotFound": "Article non trouvé",
  "common.articleNotFoundDescription": "L'article que vous recherchez n'existe pas.",
  "common.average": "Moyenne",
  "common.averageOverThePeriod": "Moyenne sur la période",
  "common.away": "Absent",
  "common.back": "Retour",
  "common.backToHelpCenter": "Retour au centre d'aide",
  "common.backToHome": "Retour à l'Accueil",
  "common.bad": "Mauvais",
  "common.batteryLevel": "Niveau de batterie",
  "common.bestValue": "Meilleure Offre",
  "common.billingDetailsAndroid": "Pour l'offre d'essai gratuit, vous ne serez pas facturé si vous annulez 24 heures avant l'expiration de la période de lancement gratuite. Une fois l'essai terminé, vous pouvez annuler l'abonnement à SmartMixin à tout moment via les paramètres de votre compte Google Play, ou il sera automatiquement renouvelé. Cela doit être fait 24 heures avant la fin de la période d'abonnement pour éviter d'être facturé d'autres frais indiqués dans le bouton ci-dessus. Les paiements d'abonnement seront facturés sur votre compte Google Play lors de la confirmation de votre achat et au début de chaque durée de renouvellement.",
  "common.billingDetailsIos": "Pour l'offre d'essai gratuit, vous ne serez pas facturé si vous annulez 24 heures avant l'expiration de la période de lancement gratuite. Une fois l'essai terminé, vous pouvez annuler l'abonnement à SmartMixin à tout moment via les paramètres de votre compte App Store, ou il sera automatiquement renouvelé. Cela doit être fait 24 heures avant la fin de la période d'abonnement pour éviter d'être facturé d'autres frais indiqués dans le bouton ci-dessus. Les paiements d'abonnement seront facturés sur votre compte App Store lors de la confirmation de votre achat et au début de chaque durée de renouvellement.",
  "common.boilerOn": "En chauffe",
  "common.browseByCategory": "Parcourir par catégorie",
  "common.calendarView": "Vue du calendrier",
  "common.cancel": "Annuler",
  "common.cannotBeEmpty": "Ce champ ne peut pas être vide.",
  "common.cardDetails": "Détails de la carte",
  "common.categoryNotFound": "Catégorie introuvable",
  "common.categoryNotFoundDescription": "Cette catégorie n'existe pas ou ne contient aucun article.",
  "common.charts": "Graphiques",
  "common.chartView": "Vue graphique",
  "common.clearRecentLocations": "Effacer tout",
  "common.close": "Fermer",
  "common.comparison": "Comparaison",
  "common.contactMe": "Me contacter",
  "common.currentDay": "Aujourd'hui",
  "common.currentLocation": "Emplacement actuel",
  "common.currentObservations": "Dernières observations",
  "common.currentRainEvent": "Événement pluvieux actuel",
  "common.currentRate": "Intensité de pluie",
  "common.currentWeatherConditions": "Conditions actuelles",
  "common.customizeComparisonMetrics": "Personnaliser les métriques",
  "common.customizeComparisonMetricsDescription": "Faites glisser les éléments pour réorganiser vos métriques de comparaison. Appuyez sur l'icône œil pour afficher ou masquer des métriques.",
  "common.customizeDashboard": "Personnaliser",
  "common.customizeDashboardDescription": "Faites glisser les éléments pour réorganiser votre tableau de bord. Appuyez sur l'icône œil pour afficher ou masquer des sections.",
  "common.customizedStationName": "Nom de station personnalisé",
  "common.dailyForecast": "Prévisions quotidiennes",
  "common.dashboard": "Synthèse",
  "common.default": "Par défaut",
  "common.defaultForecastModelChip": "Par défaut · {name}",
  "common.delete": "Supprimer",
  "common.deleteAccount": "Supprimer le compte",
  "common.deleteAccountConfirmation": "Êtes-vous sûr de vouloir supprimer votre compte ? Cette action est irréversible.",
  "common.deleteAccountDescription": "Cette action supprime votre compte et toutes vos informations. il n'y a pas de retour en arrière.",
  "common.details": "Détails",
  "common.edit": "Modifier",
  "common.editor": "Éditeur",
  "common.endTime": "Fin",
  "common.exitFullscreen": "Quitter le plein écran",
  "common.exploreWeatherMap": "Explorer la Carte Météo",
  "common.favoriteLocations": "Favoris",
  "common.favoriteLocationsEmpty": "Vous pouvez ajouter jusqu'à 5 emplacements favoris.",
  "common.favoriteStations": "Favoris",
  "common.feedbackHelpsImprove": "Vos commentaires nous aident à améliorer nos articles d'aide.",
  "common.feedbackReasonNotAnswer": "Il ne répond pas à ma question",
  "common.feedbackReasonOutdated": "Les informations sont obsolètes",
  "common.feedbackReasonUnclear": "Les instructions ne sont pas claires",
  "common.feedbackWhatWentWrong": "Quel était le problème ?",
  "common.filterStationDescription": "Ne pas afficher les stations dont les mesures ne sont pas fiables",
  "common.filterStations": "Filtrer les stations",
  "common.filterStationSourceDescription": "Sélectionner les fournisseurs de stations que vous souhaitez afficher sur la carte",
  "common.findStationsNearYou": "Trouver des stations près de chez vous",
  "common.firmwareVersion": "Version du micrologiciel",
  "common.forecast": "Prévisions",
  "common.forecastComparisonDescription": "Comparez facilement les données des différents modèles météo disponibles",
  "common.forecastModelComparison": "Comparaison de modèles météo",
  "common.forecastModelCoverage": "Couverture",
  "common.forecastModelDescription": "Description",
  "common.forecastModelDescription_AROME": "Modèle haute résolution de Météo France à convection résolue couvrant l’Europe occidentale à 1,3 km. Référence pour les prévisions à court terme en France ; actualisé toutes les trois heures.",
  "common.forecastModelDescription_ARPEGE_EU": "Maille européenne du modèle ARPEGE de Météo France à 10 km de résolution. Prévisions à moyenne échéance sur l’Europe, actualisées quatre fois par jour.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Modèle global de prévision numérique du temps de Météo France à 25 km de résolution, jusqu’à environ 4 jours. Actualisé quatre fois par jour.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI de DMI : modèle à convection résolue sur le nord-ouest de l'Europe — Danemark, Benelux, Irlande, Royaume-Uni et Scandinavie — 2 km de résolution, jusqu'à 60 heures, actualisé huit fois par jour. Contient des données ouvertes DMI modifiées (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Système global déterministe de prévision d’Environnement Canada : modèle mondial à moyenne échéance, 15 km de résolution, jusqu’à 10 jours, actualisé deux fois par jour.",
  "common.forecastModelDescription_EC_HRDPS": "Système déterministe de prévision à haute résolution d’Environnement Canada : modèle à convection résolue sur le Canada et le nord des États-Unis, 2,5 km de résolution, jusqu’à 48 heures, actualisé quatre fois par jour.",
  "common.forecastModelDescription_EC_RDPS": "Système régional déterministe de prévision d’Environnement Canada : modèle à moyenne échéance sur l’Amérique du Nord à 10 km de résolution, actualisé quatre fois par jour.",
  "common.forecastModelDescription_ECMWF_HRES": "Le modèle haute résolution (IFS) du Centre européen pour les prévisions météorologiques à moyen terme, largement considéré comme le meilleur système de prévision mondial. Couvre l'ensemble de la planète à une résolution de 25 km jusqu'à 15 jours, mis à jour quatre fois par jour. Contient des données ouvertes ECMWF modifiées (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "Modèle global de référence à moyenne échéance de la NOAA. Couvre toute la planète à 25 km de résolution jusqu’à 16 jours, actualisé quatre fois par jour.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh de la NOAA : modèle à convection résolue sur les États-Unis continentaux à 3 km de résolution, actualisé toutes les heures. Idéal pour les prévisions à très court terme des orages et de la météo violente.",
  "common.forecastModelDescription_ICON": "Le modèle global ICON du DWD à une résolution de 13 km couvrant l'ensemble de la planète jusqu'à 7,5 jours, actualisé quatre fois par jour. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I d'ItaliaMeteo, opéré avec ARPAE : modèle à convection résolue sur l'Italie — 2,2 km de résolution, jusqu'à 72 heures, actualisé deux fois par jour. Contient des données ouvertes ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "Run de contrôle ICON-CH1-EPS de MeteoSwiss : modèle à convection résolue sur les Alpes — 1 km de résolution, jusqu'à 33 heures, actualisé toutes les trois heures.",
  "common.forecastModelDescription_ICON_CH2": "Run de contrôle ICON-CH2-EPS de MeteoSwiss : modèle à convection résolue sur les Alpes — Suisse et région alpine environnante — 2,1 km de résolution, jusqu'à 120 heures, actualisé quatre fois par jour.",
  "common.forecastModelDescription_ICON_DE": "Modèle haute résolution de DWD à convection résolue sur l’Allemagne et les pays voisins à 2,2 km de résolution. Prévisions à court terme actualisées deux fois par jour. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "Maille européenne du modèle ICON de DWD à 7 km de résolution couvrant l’Europe et l’Atlantique nord. Prévisions à moyenne échéance actualisées quatre fois par jour. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "Service de prévision météo ouvert de l’Institut météorologique norvégien, combinant des modèles nordiques haute résolution et les données ECMWF pour fournir des prévisions mondiales jusqu’à 10 jours.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Maille AROME sur les Antilles françaises (Guadeloupe, Martinique) à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Maille AROME sur la Guyane française à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Maille AROME sur la Nouvelle-Calédonie à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Maille AROME sur la Polynésie française à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Maille AROME sur la Réunion et Mayotte à 2,5 km de résolution. Prévisions à court terme actualisées quatre fois par jour.",
  "common.forecastModelDescription_NAM_CONUS": "Maille du modèle North American Mesoscale de la NOAA sur les États-Unis continentaux à 5 km de résolution. Prévisions à courte échéance actualisées quatre fois par jour.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Modèle North American Mesoscale de la NOAA couvrant toute l’Amérique du Nord à 32 km de résolution. Actualisé quatre fois par jour.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "La prévision phare de SmartMixin. Pour chaque heure à votre position, nous choisissons le meilleur modèle disponible — généralement un modèle régional haute résolution là où il en existe un (AROME en France, ICON-D2 en Allemagne, HRRR aux États-Unis, ARPEGE Europe sur le continent…) et nous nous rabattons sur un modèle global ailleurs — puis nous comblons les manques à partir de sources voisines. Le résultat : une prévision unique et homogène couvrant n’importe quel point du globe jusqu’à 14 jours, automatiquement rafraîchie à chaque mise à jour de l’un des modèles sous-jacents.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Prévision mondiale propriétaire de Weatherflow combinant plusieurs modèles numériques de prévision avec les observations de son réseau de stations météo Tempest. Horizon mondial de 10 jours.",
  "common.forecastModelDetailTitle": "Modèle de prévision",
  "common.forecastModelScopeGlobal": "Mondial",
  "common.forecastModelScopeGlobalDescription": "Ce modèle couvre l’ensemble de la planète.",
  "common.forecastModelScopeRegional": "Régional",
  "common.forecastModelScopeRegionalDescription": "Ce modèle ne couvre qu’une région spécifique.",
  "common.forecastModelSpecifications": "Spécifications",
  "common.forecastSources": "Sources des prévisions",
  "common.freeAccount": "Compte gratuit",
  "common.freeSubscription": "Abonnement offert",
  "common.freeTrialForPeriod": "Essai gratuit pendant {period} jours",
  "common.frequency": "Fréquence",
  "common.full": "Plein",
  "common.fullscreen": "Plein écran",
  "common.getStartedFree": "Commencer Gratuitement",
  "common.getUnlimitedAccess": "Accès illimité à :",
  "common.good": "Bon",
  "common.hail": "Grêle",
  "common.help": "Aide",
  "common.helpCategoryAccount": "Compte",
  "common.helpCategoryBilling": "Facturation",
  "common.helpCategoryGettingStarted": "Premiers pas",
  "common.helpCategoryProviders": "Fournisseurs",
  "common.helpCategoryStations": "Stations",
  "common.helpCategoryTroubleshooting": "Dépannage",
  "common.helpCenter": "Centre d'aide",
  "common.helpCenterDescription": "Trouvez des réponses aux questions fréquentes et apprenez à tirer le meilleur parti de SmartMixin.",
  "common.hg": "Hors-gel",
  "common.hidden": "Masqués",
  "common.hiddenSensors": "Capteurs masqués",
  "common.hiddenStations": "Stations masquées",
  "common.hiddenStationsDescription": "Vous pouvez dévoiler une station en appuyant sur l'icône 'œil' à côté.",
  "common.high": "Haut",
  "common.home": "Accueil",
  "common.homeConnectService": "Vous possédez une station météo ? Connectez votre service",
  "common.homeInformation": "Informations sur la maison",
  "common.homeIntroduction": "Commencez à connecter vos comptes externes pour profiter des fonctionnalités de SmartMixin.",
  "common.homeName": "Nom du domicile",
  "common.homeSubtitle": "Votre météo, tout au même endroit",
  "common.horizon": "Horizon",
  "common.horizonValue": "jusqu'à {value} heures",
  "common.iDontKnowYet": "Je ne sais pas encore",
  "common.indoor": "Intérieur",
  "common.lastRainEvent": "Dernier événement pluvieux",
  "common.lastUpdate": "Dernière mise à jour",
  "common.legendHeavy": "Forte",
  "common.legendLight": "Légère",
  "common.legendLightningHelp": "La couleur indique l'âge de chaque impact sur les {minutes} dernières minutes — les plus récents en blanc, les plus anciens en rouge foncé.",
  "common.legendNewest": "Plus récents",
  "common.legendOldest": "Plus anciens",
  "common.legendStationsHelp": "La couleur du marqueur reflète la valeur de la mesure sélectionnée.",
  "common.lightningDataAttribution": "Données de foudre : Blitzortung.org",
  "common.lightningStrikes": "Impacts de foudre",
  "common.lightningStrikesDescription": "Afficher les impacts de foudre en temps réel sur la carte",
  "common.linkToSection": "Lien vers cette section",
  "common.loading": "Chargement",
  "common.location": "Localisation",
  "common.locationAddedToFavorites": "Emplacement ajouté aux favoris",
  "common.locationNotGranted": "L'autorisation de localisation n'est pas accordée. Veuillez permettre l'accès à votre emplacement dans les paramètres de l'appareil.",
  "common.locationRemovedFromFavorites": "Emplacement supprimé des favoris",
  "common.locations": "Localisations",
  "common.low": "Faible",
  "common.manage": "Gérer",
  "common.manageAccount": "Gérer le compte",
  "common.manageMySubscription": "Gérer mon abonnement",
  "common.manageSensors": "Gérer les capteurs",
  "common.manageSensorsDescription": "Faites glisser les éléments pour réorganiser les capteurs. Appuyez sur l'icône œil pour afficher ou masquer des capteurs. Appuyez sur un nom pour le renommer.",
  "common.manualBoost": "Boost manuel",
  "common.manualSetpointUntil": "Consigne manuelle jusqu'à",
  "common.mapLayers": "Calques de la carte",
  "common.mapLegend": "Légende de la carte",
  "common.maxFavoriteLocationsReached": "Vous ne pouvez avoir que jusqu'à 5 emplacements favoris. Retirez-en un pour en ajouter un autre.",
  "common.maximum": "Maximum",
  "common.measureToDisplay": "Mesure à afficher",
  "common.medium": "Moyen",
  "common.meshSize": "Taille de la grille",
  "common.minimum": "Minimum",
  "common.minRead": "{minutes} min de lecture",
  "common.modifyFavoriteStations": "Modifier les stations préférées",
  "common.modifyFavoriteStationsDescription": "Vous pouvez réorganiser vos stations préférées en les faisant glisser. Vous pouvez également les supprimer de la liste.",
  "common.moduleType": "Type de module",
  "common.monthTotal": "Ce mois-ci",
  "common.more": "Plus",
  "common.moreInformation": "Plus d'informations",
  "common.myLocation": "Ma position",
  "common.nearbyWeatherStations": "Stations météo à proximité",
  "common.next": "Suivant",
  "common.nextHours": "Heures à venir",
  "common.no": "Non",
  "common.noAccountNeeded": "Aucun compte requis",
  "common.noDataForThisPeriod": "Pas de données pour cette période",
  "common.noLocationsFound": "Aucun lieu trouvé",
  "common.noNetatmoWeatherStationYet": "Vous n'avez pas de station météo Netatmo",
  "common.noOutdoorModule": "Il n'y a pas de module extérieur fonctionnel pour cette station.",
  "common.noSearchResults": "Aucun article ne correspond à votre recherche",
  "common.noStationsFound": "Aucune station trouvée",
  "common.noThermostatYet": "Vous n'avez pas de thermostat Netatmo",
  "common.notNow": "Pas maintenant",
  "common.notPurchasedYet": "Il semble qu'aucun achat n'ait été effectué.",
  "common.noWeatherStation": "Pas de station météo",
  "common.noWeatherStationYet": "Vous n'avez pas de station météo",
  "common.numberOfActiveWarnings": "{warning_count} avertissements météo actifs",
  "common.onThisPage": "Sur cette page",
  "common.openSettings": "Paramètres",
  "common.orChooseMonthly": "Ou choisir mensuel :",
  "common.outdatedModule": "Les données de ce module sont obsolètes.",
  "common.outdoor": "Extérieur",
  "common.outdoorTemperature": "Température extérieure",
  "common.pageNotFound": "Page Non Trouvée",
  "common.pageNotFoundDescription": "La page que vous recherchez n'existe pas ou a été déplacée.",
  "common.passwordUpdated": "Mot de passe mis à jour avec succès.",
  "common.personalWeatherIntelligence": "Votre Intelligence Météo Personnelle",
  "common.platformMobileApp": "Application mobile",
  "common.platformMobileOnly": "Application mobile uniquement",
  "common.platformWebApp": "Application web",
  "common.platformWebOnly": "Application web uniquement",
  "common.popularArticles": "Articles populaires",
  "common.premiumAccount": "Compte Premium",
  "common.premiumDescription": "L'abonnement Premium déverrouille une grande variété de fonctionnalités supplémentaires telles que l'analyse météorologique avancée, la comparaison de données, les modèles de prévisions régionales et bien plus encore.",
  "common.premiumFeatureAlerts": "Alertes Météo",
  "common.premiumFeatureAnalysis": "Analyse Météo Avancée",
  "common.premiumFeatureCharts": "Comparaisons de Graphiques",
  "common.premiumFeatureExport": "Export de Données",
  "common.premiumFeatureForecast": "Modèles de Prévisions Régionaux",
  "common.premiumFeatureNotification": "Widget Barre d'État",
  "common.premiumFeatureTitle": "Fonctionnalité Premium",
  "common.premiumFeatureWidgets": "Widgets d'écran d'accueil",
  "common.pressureSummary": "Synthèse de la pression",
  "common.previous": "Précédent",
  "common.previousHours": "Heures précédentes",
  "common.profileUpdated": "Profil mis à jour avec succès.",
  "common.purchasedNetatmoPro": "Vous avez précédemment acheté Netatmo Pro ({date}). Souscrivez à l'une des offres ci-dessous pour avoir accès à toutes les fonctionnalités premium de l'application.",
  "common.radarDataAttribution": "Données radar : RainViewer.com",
  "common.rain": "Pluie",
  "common.rainEvents": "Evénements pluvieux",
  "common.rainfallMeasurement": "Mesure des précipitations",
  "common.rainRadar": "Radar de pluie",
  "common.rainRadarDescription": "Afficher la superposition du radar de pluie sur la carte",
  "common.rainSummary": "Synthèse des précipitations",
  "common.range": "Amplitude",
  "common.recentLocations": "Récent",
  "common.recentLocationsEmpty": "Votre historique récent est vide.",
  "common.recentStations": "Stations récentes",
  "common.relatedArticles": "Articles connexes",
  "common.relay": "Relai",
  "common.removeFromFavorites": "Supprimer des favoris",
  "common.renameSensors": "Renommer les capteurs",
  "common.resetZoom": "Réinitialiser le zoom",
  "common.restorePurchase": "Restaurer un achat",
  "common.room": "Pièce",
  "common.rooms": "Pièces",
  "common.savingsPercent": "Économisez {percent}%",
  "common.searchArticles": "Rechercher des articles...",
  "common.searchForALocation": "Rechercher un lieu...",
  "common.searchForLocation": "Rechercher un lieu",
  "common.searchForWeatherStation": "Rechercher une station météo",
  "common.searchResults": "Résultats de la recherche",
  "common.searchResultsEmpty": "Aucun résultat trouvé.",
  "common.searchResultsFound": "{count, plural, one {# résultat trouvé} other {# résultats trouvés}}",
  "common.searchStationsDescription": "Entrez une ville, une adresse ou un nom de lieu pour trouver des stations météo à proximité.",
  "common.searchStationsHint": "Utilisez la barre de recherche ci-dessus pour découvrir des stations météo partout dans le monde.",
  "common.selectStationForComparison": "Sélectionner une station pour la comparaison",
  "common.selectWeatherForecastProvider": "Veuillez choisir un fournisseur météo",
  "common.serialNumber": "Numéro de série",
  "common.share": "Partager",
  "common.shareOutdoorMeasures": "Partagez vos mesures extérieures",
  "common.shareOutdoorMeasuresDescription": "Participez à la communauté SmartMixin en partageant vos données extérieures. Les données des modules intérieurs ne seront jamais partagées.",
  "common.shareYourWeather": "Partagez votre météo",
  "common.signalStrength": "Force du signal",
  "common.skip": "Passer",
  "common.smartThermostat": "Thermostat intelligent",
  "common.smartValve": "Vanne intelligente",
  "common.snow": "Neige",
  "common.start": "Commencer",
  "common.startFreeTrial": "Démarrer l'Essai Gratuit",
  "common.startTime": "Début",
  "common.station": "station",
  "common.stationAddedToFavorites": "Station ajoutée aux favoris",
  "common.stationComparison": "Comparaison de stations",
  "common.stationComparisonDescription": "Permet de comparer les données météo historiques avec celles d'une autre station.",
  "common.stationInformation": "Informations sur la station",
  "common.stationName": "Nom de la Station",
  "common.stationObservationsDescription": "Afficher les dernières observations des stations météo",
  "common.stationRemovedFromFavorites": "Station supprimée des favoris",
  "common.stations": "stations",
  "common.stationsNear": "Stations près de",
  "common.stationType": "Type de station",
  "common.statusOffline": "Hors ligne",
  "common.statusOnline": "En ligne",
  "common.statusStale": "Obsolète",
  "common.statusSyncing": "Synchronisation",
  "common.stillNeedHelp": "Besoin d'aide supplémentaire ?",
  "common.stillNeedHelpDescription": "Si cet article n'a pas répondu à votre question, je serai ravi de vous aider directement.",
  "common.subscribeNow": "S'abonner maintenant - sans essai",
  "common.sumOverThePeriod": "Cumulé sur la période",
  "common.switchToPremium": "Passer à SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Synthèse de la température",
  "common.thankYouForFeedback": "Merci pour votre retour !",
  "common.thenPrice": "puis {price}",
  "common.timeSelection": "Sélection de l'heure",
  "common.timezone": "Fuseau horaire",
  "common.totalDuration": "Durée totale",
  "common.tryAnotherLocation": "Nous n'avons trouvé aucune station météo près de cet emplacement. Essayez de rechercher une autre zone.",
  "common.unknown": "Inconnu",
  "common.untilChanged": "Jusqu'à nouvel ordre",
  "common.untilTime": "Jusqu'à {time}",
  "common.updateAvailable": "Mise à jour disponible",
  "common.updateAvailableOpenAppStore": "Touchez pour ouvrir l'App Store",
  "common.updateAvailableOpenGooglePlay": "Touchez pour ouvrir Google Play",
  "common.updateAvailableVersion": "Mise à jour disponible : v{version}",
  "common.upgrade": "Mettre à niveau",
  "common.upgradeRequiredAndroid": "Une mise à jour de votre application est requise, accédez à Google Play pour la mise à niveau.",
  "common.upgradeRequiredIos": "Une mise à jour de votre application est requise, accédez au magasin d'applications pour la mise à niveau.",
  "common.validate": "Valider",
  "common.validEmail": "Une adresse e-mail valide est requise.",
  "common.very_low": "Très faible",
  "common.visitNetatmoWebsite": "Site web Netatmo",
  "common.wasArticleHelpful": "Cet article vous a-t-il été utile ?",
  "common.weatherCondition": "Condition météo",
  "common.weatherflowNCRain": "NC Rain (Nearcast)",
  "common.weatherflowNCRainDescription": "NC Rain est une source de données supplémentaire fournie via le système météo Tempest, alimenté par la technologie Nearcast. Les données NC Rain sont une estimation de l'accumulation moyenne de précipitations autour de votre Tempest.",
  "common.weatherForecastModels": "Modèles de prévisions météo",
  "common.weatherIntelligencePlatform": "La Plateforme d'Intelligence Météo",
  "common.weatherMap": "Carte météo",
  "common.weatherMapMetaDescription": "SmartMixin propose des cartes météo interactives et des radars de pluie pour les conditions météorologiques dans le monde entier.",
  "common.weatherObservations": "Observations météo",
  "common.weatherStation": "Station météo",
  "common.weatherStations": "Stations météo",
  "common.welcome": "Bienvenue sur SmartMixin !",
  "common.whenBackHome": "Quand serez-vous de retour à la maison ?",
  "common.wifiStrength": "Force WiFi",
  "common.wind": "Vent",
  "common.windMeasurement": "Mesure du vent",
  "common.windSpeed": "Vitesse du vent",
  "common.windSummary": "Synthèse du vent",
  "common.yearToDate": "Cette année",
  "common.yes": "Oui",
  "common.zoomImage": "Agrandir l'image",
  "forecastMaps.addColor": "Ajouter une couleur",
  "forecastMaps.addLayer": "Ajouter une couche",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Retour aux cartes",
  "forecastMaps.browseMaps": "Parcourir les cartes",
  "forecastMaps.build": "Générer",
  "forecastMaps.buildCompleted": "Génération terminée",
  "forecastMaps.builderMetaDescription": "Composez des cartes de prévision personnalisées à partir des couches des modèles météo.",
  "forecastMaps.builderTitle": "Créateur de cartes",
  "forecastMaps.buildFailed": "La génération a échoué. Veuillez réessayer.",
  "forecastMaps.buildNotPossible": "Cette carte ne peut pas encore être générée — aucune donnée de prévision n'est disponible.",
  "forecastMaps.buildProgress": "Rendu… {completed}/{total} étapes",
  "forecastMaps.buildStarting": "Démarrage de la génération…",
  "forecastMaps.byModel": "Par modèle",
  "forecastMaps.byZone": "Par zone",
  "forecastMaps.colormap": "Palette de couleurs",
  "forecastMaps.colormapCustom": "Couleurs personnalisées",
  "forecastMaps.colormapGroupDomain": "Palettes météo",
  "forecastMaps.colormapGroupMatplotlib": "Palettes scientifiques",
  "forecastMaps.colorScale": "Échelle de couleurs",
  "forecastMaps.comingSoon": "Cette vue arrive bientôt.",
  "forecastMaps.contourLevels": "Niveaux de contour",
  "forecastMaps.countryCanada": "Canada",
  "forecastMaps.countryFrance": "France",
  "forecastMaps.countryGermany": "Allemagne",
  "forecastMaps.countryItaly": "Italie",
  "forecastMaps.countryScandinavia": "Scandinavie",
  "forecastMaps.countrySpain": "Espagne",
  "forecastMaps.countrySwitzerland": "Suisse",
  "forecastMaps.countryUnitedStates": "États-Unis",
  "forecastMaps.customColormapMinColors": "Une palette personnalisée nécessite au moins deux couleurs",
  "forecastMaps.customExtent": "Emprise personnalisée",
  "forecastMaps.deleteMap": "Supprimer la carte",
  "forecastMaps.deleteMapBody": "« {name} » et ses rendus seront définitivement supprimés.",
  "forecastMaps.deleteMapTitle": "Supprimer cette carte ?",
  "forecastMaps.displayName": "Nom affiché",
  "forecastMaps.downloadMp4": "Télécharger le MP4",
  "forecastMaps.downscaling": "Facteur d'espacement des barbules",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Dessiner la zone",
  "forecastMaps.east": "Est",
  "forecastMaps.editMap": "Modifier la carte",
  "forecastMaps.exportBuilding": "Préparation de la vidéo…",
  "forecastMaps.exportError": "L'export de la vidéo a échoué. Veuillez réessayer.",
  "forecastMaps.exportMp4": "Exporter en MP4",
  "forecastMaps.exportNotReady": "La vidéo n'est pas encore prête. Veuillez réessayer plus tard.",
  "forecastMaps.extentDrawHint": "Faites glisser sur la carte pour dessiner la zone",
  "forecastMaps.extentInvalid": "L'ouest doit être inférieur à l'est et le sud inférieur au nord",
  "forecastMaps.extentPanZoomHint": "Déplacez et zoomez jusqu'à ce que la zone remplisse le cadre",
  "forecastMaps.flipbookView": "Animation",
  "forecastMaps.forecastModel": "Modèle de prévision",
  "forecastMaps.forkAndEdit": "Dupliquer et modifier",
  "forecastMaps.height": "Hauteur (pouces)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Couleur invalide — utilisez #RRGGBB",
  "forecastMaps.layers": "Couches",
  "forecastMaps.layerTypeBarbs": "Barbules de vent",
  "forecastMaps.layerTypeContour": "Lignes de contour",
  "forecastMaps.layerTypeFilledContour": "Contours remplis",
  "forecastMaps.layerTypeMagnitude": "Magnitude",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Champ de vecteurs",
  "forecastMaps.leave": "Quitter",
  "forecastMaps.levelsCount": "Nombre",
  "forecastMaps.levelsInvalid": "Niveaux de contour invalides",
  "forecastMaps.levelsModeArange": "Pas fixe",
  "forecastMaps.levelsModeExplicit": "Valeurs explicites",
  "forecastMaps.levelsModeLinspace": "Régulièrement espacés (nombre)",
  "forecastMaps.levelsStep": "Pas",
  "forecastMaps.levelsValues": "Valeurs",
  "forecastMaps.levelsValuesHint": "Séparées par des virgules, croissantes",
  "forecastMaps.localTimeHint": "Affiché dans votre heure locale",
  "forecastMaps.map": "Carte",
  "forecastMaps.mapDescription": "Description",
  "forecastMaps.mapName": "Nom de la carte",
  "forecastMaps.mapNameRequired": "Saisissez un nom",
  "forecastMaps.mapSettings": "Paramètres de la carte",
  "forecastMaps.mapView": "Carte interactive",
  "forecastMaps.maxLayersReached": "Cette carte a atteint le maximum de {max} couches.",
  "forecastMaps.maxValue": "Valeur max",
  "forecastMaps.memoryBudgetExceeded": "La résolution dépasse le budget de rendu — réduisez le DPI ou la hauteur",
  "forecastMaps.memoryBudgetUsage": "Budget de rendu : {percent}%",
  "forecastMaps.metaDescription": "Cartes de prévision animées générées à partir des modèles météo.",
  "forecastMaps.metric": "Mesure",
  "forecastMaps.metricRequired": "Sélectionnez une mesure",
  "forecastMaps.metricUnavailable": "Indisponible pour ce modèle",
  "forecastMaps.minBelowMax": "Le min doit être inférieur au max",
  "forecastMaps.minMaxRequired": "Les valeurs min et max sont requises pour ce type de couche",
  "forecastMaps.minValue": "Valeur min",
  "forecastMaps.modelNoRun": "Aucun run terminé pour le moment",
  "forecastMaps.moveLayerDown": "Descendre",
  "forecastMaps.moveLayerUp": "Monter",
  "forecastMaps.myMaps": "Mes cartes",
  "forecastMaps.nanClipToMin": "Limiter au min",
  "forecastMaps.nanMask": "Masquer",
  "forecastMaps.nanPolicy": "Données manquantes",
  "forecastMaps.nanSkip": "Ignorer",
  "forecastMaps.newMap": "Nouvelle carte",
  "forecastMaps.noCompletedRun": "Cette carte n'a pas encore été générée. Revenez bientôt.",
  "forecastMaps.noLayers": "Aucune couche pour le moment. Ajoutez une couche pour commencer.",
  "forecastMaps.noMapsAvailable": "Aucune carte de prévision n'est disponible pour le moment.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacité",
  "forecastMaps.overlayLegend": "Légende",
  "forecastMaps.pause": "Pause",
  "forecastMaps.play": "Lecture",
  "forecastMaps.pointValueError": "Impossible de charger la prévision pour ce point.",
  "forecastMaps.pointValueLoading": "Chargement de la prévision…",
  "forecastMaps.pointValueUnavailable": "Aucune donnée pour cette heure.",
  "forecastMaps.presets": "Prédéfinies",
  "forecastMaps.preview": "Aperçu",
  "forecastMaps.previewEmptyHint": "Configurez au moins une couche valide pour générer un aperçu.",
  "forecastMaps.previewFailed": "L'aperçu a échoué",
  "forecastMaps.previewHour": "Heure de prévision",
  "forecastMaps.previewRendering": "Rendu de l'aperçu…",
  "forecastMaps.projection": "Projection",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Stéréographique",
  "forecastMaps.regionEurope": "Europe",
  "forecastMaps.regionNorthAmerica": "Amérique du Nord",
  "forecastMaps.removeColor": "Supprimer la couleur",
  "forecastMaps.removeLayer": "Supprimer la couche",
  "forecastMaps.retry": "Réessayer",
  "forecastMaps.run": "Run : {run}",
  "forecastMaps.save": "Enregistrer",
  "forecastMaps.selectExtentOnMap": "Sélectionner la zone sur la carte",
  "forecastMaps.south": "Sud",
  "forecastMaps.title": "Cartes de prévision",
  "forecastMaps.uMetric": "Composante U",
  "forecastMaps.unitConversion": "Conversion d'unités",
  "forecastMaps.unitNone": "Aucune",
  "forecastMaps.unsavedChangesBody": "Vous avez des modifications non enregistrées. Quitter et les abandonner ?",
  "forecastMaps.unsavedChangesTitle": "Modifications non enregistrées",
  "forecastMaps.useCurrentView": "Utiliser la vue actuelle",
  "forecastMaps.useModelDomain": "Désactivé : le domaine complet du modèle est utilisé",
  "forecastMaps.utcTime": "UTC : {time}",
  "forecastMaps.uvMetricsDiffer": "Les mesures U et V doivent être différentes",
  "forecastMaps.validTime": "Valide à {time}",
  "forecastMaps.valueBetween": "Doit être compris entre {min} et {max}",
  "forecastMaps.variable": "Variable",
  "forecastMaps.viewMap": "Voir la carte",
  "forecastMaps.vMetric": "Composante V",
  "forecastMaps.west": "Ouest",
  "forecastMaps.windAnimation": "Animation du vent",
  "intro.locationDescription": "Autorisez l’accès à votre position pour obtenir des prévisions précises adaptées à votre emplacement exact — fini les bulletins météo génériques.",
  "intro.locationTitle": "Des prévisions faites pour vous",
  "intro.notificationDescription": "Activez les notifications pour recevoir des alertes en temps réel sur les changements météo importants — pluie, neige ou conditions extrêmes, au bon moment.",
  "intro.notificationsTitle": "Ne ratez aucun changement météo",
  "intro.readyDescription": "Profitez de prévisions précises, d’observations en direct et de données de stations du monde entier — le tout dans une seule application.",
  "intro.readyTitle": "C’est parti !",
  "intro.welcomeDescription": "Recevez des prévisions hyperlocales issues des meilleures agences météo — et accédez à plus de 40 000 stations dans le monde pour consulter les conditions réelles, passées et présentes.",
  "intro.welcomeTitle": "La météo, réinventée pour vous",
  "landing.alerts": "Alertes",
  "landing.alertsDescription": "Créez vos propres alertes et soyez averti dès qu'elles sont déclenchées.",
  "landing.featureAlertsDescription": "Définissez des seuils personnalisés pour n'importe quelle mesure. Soyez alerté quand la température chute, la pluie commence ou le vent se lève.",
  "landing.featureAlertsTitle": "Alertes intelligentes",
  "landing.featureAnalyticsDescription": "Graphiques interactifs, analyse des tendances et statistiques détaillées. Explorez en profondeur les données de température, humidité, pression, pluie et vent.",
  "landing.featureAnalyticsTitle": "Analyses avancées",
  "landing.featureExportDescription": "Téléchargez vos données météo en fichiers CSV pour une analyse approfondie dans Excel, Google Sheets ou vos outils préférés.",
  "landing.featureExportTitle": "Exportez vos données",
  "landing.featureForecastDescription": "Accédez à plus de 10 modèles de prévisions professionnels dont ECMWF, GFS et des modèles régionaux. Comparez-les côte à côte pour faire vos propres prédictions.",
  "landing.featureForecastTitle": "Comparez les modèles de prévisions",
  "landing.featureHistoryDescription": "Accédez aux données historiques avec une échelle horaire, journalière et mensuelle. Exportez en CSV pour la recherche ou vos archives personnelles.",
  "landing.featureHistoryTitle": "Historique complet",
  "landing.featureMultiBrandDescription": "Connectez Netatmo, Davis, Tempest, Ecowitt, Ambient Weather et plus encore. Fini de jongler entre les applications.",
  "landing.featureMultiBrandTitle": "Toutes les marques, une seule app",
  "landing.featuresSubtitle": "SmartMixin vous donne les outils pour analyser, comparer et comprendre vos données météo comme un pro.",
  "landing.featuresTitle": "Conçu pour les passionnés de données",
  "landing.finalCtaButton": "Créer un compte gratuit",
  "landing.finalCtaSubtitle": "Rejoignez des milliers de passionnés de météo qui font confiance à SmartMixin.",
  "landing.finalCtaTitle": "Prêt à explorer vos données météo en profondeur ?",
  "landing.forecastDescription": "Accédez aux meilleurs modèles de prévisions météorologiques et comparez-les pour vous faire votre propre idée du temps qu'il fera.",
  "landing.forecasts": "Prévisions",
  "landing.heroCta": "Commencer gratuitement",
  "landing.heroDescription": "Analyses poussées, graphiques élégants et prévisions professionnelles — toutes vos stations météo réunies dans une application puissante.",
  "landing.heroSecondaryCta": "Explorer la carte",
  "landing.heroTagline": "Pour les passionnés de météo",
  "landing.heroTitle": "Visualisez votre météo comme jamais",
  "landing.pricingFeatureAdvancedMetrics": "Métriques avancées",
  "landing.pricingFeatureAlerts": "Alertes personnalisées",
  "landing.pricingFeatureExport": "Export de données (CSV)",
  "landing.pricingFeatureForecastComparison": "Comparaison des prévisions",
  "landing.pricingFeatureForecasts": "Modèles de prévisions",
  "landing.pricingFeatureForecastsFreeTier": "1 modèle",
  "landing.pricingFeatureForecastsPremiumTier": "10+ modèles",
  "landing.pricingFeatureReports": "Analyses et rapports",
  "landing.pricingFeatureStationComparison": "Comparaison de stations",
  "landing.pricingFeatureWidgets": "Widgets écran d'accueil",
  "landing.pricingFeatureYearOverYear": "Analyse année par année",
  "landing.pricingFree": "Gratuit",
  "landing.pricingFreeCta": "Commencer",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Le plus populaire",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Commencer",
  "landing.pricingPremiumDescription": "À partir de 1,99 €/mois — abonnez-vous sur le web, l'App Store ou Google Play",
  "landing.pricingSubtitle": "Commencez gratuitement, passez à Premium quand vous avez besoin de plus.",
  "landing.pricingTitle": "Tarification simple et transparente",
  "landing.smartMixinDescription": "SmartMixin est une application qui donne accès à votre station météo et à plus de 40 000 autres stations dans le monde. Elle vous aide à visualiser et à comprendre les données météorologiques.",
  "landing.statBrands": "Marques supportées",
  "landing.statForecasts": "Modèles de prévisions",
  "landing.statStations": "Stations météo",
  "landing.supportedDevices": "Périphériques compatibles",
  "landing.supportedDevicesDescription": "En plus des stations de l'Organisation météorologique mondiale, SmartMixin prend en charge un nombre croissant de marques de stations météorologiques.",
  "landing.supportedDevicesNote": "Plus de 40 000 stations publiques de l'Organisation météorologique mondiale",
  "landing.supportedDevicesSubtitle": "Connectez votre station météo existante en quelques minutes. Nous supportons 8 grandes marques et plus encore.",
  "landing.supportedDevicesTitle": "Compatible avec votre station",
  "landing.thermostatDescription": "Connectez votre thermostat Netatmo pour corréler les habitudes de chauffage avec les conditions extérieures.",
  "landing.thermostatManufacturers": "Les fabricants de thermostats sont également pris en charge pour corréler le chauffage avec les conditions extérieures.",
  "landing.thermostatTitle": "Intégration maison connectée",
  "landing.weatherAnalysis": "Analyse météorologique",
  "landing.weatherAnalysisDescription": "SmartMixin est livré avec de nombreuses visualisations de données qui vous permettent d'analyser les données météorologiques.",
  "landing.weatherAssistant": "Votre assistant météo",
  "landing.weatherAssistantDescription": "Que vous soyez intéressé par les conditions météorologiques actuelles, historiques ou prévues, SmartMixin fournit de nombreuses informations dès que vous en avez besoin.",
  "landing.weatherForecastModels": "Modèles de prévisions météo",
  "landing.weatherForecastModelsDescription": "SmartMixin donne accès aux modèles de prévisions météorologiques les plus précis. Vous pouvez facilement comparer leurs prévisions et vous faire votre propre idée.",
  "landing.weatherMap": "Carte météorologique",
  "landing.weatherMapDescription": "Parcourez la carte et visualisez la météo partout dans le monde.",
  "network.cancelError": "Requête annulée",
  "network.connectionError": "Serveur injoignable",
  "network.networkError": "Réseau non disponible",
  "network.serverError": "Un problème est survenu ...",
  "network.timeoutError": "Délai de connexion dépassé",
  "network.unknownError": "Erreur inconnue",
  "providerHints.ambientWeatherApiKey": "Créée dans les paramètres de votre compte ambientweather.net.",
  "providerHints.davisApiSecret": "Affiché une seule fois lors de la création de la clé API V2 — conservez-le précieusement.",
  "providerHints.davisV2ApiKey": "Depuis la page des clés API V2 de weatherlink.com.",
  "providerHints.ecowittApi": "Depuis la page API de votre compte Ecowitt.",
  "providerHints.ecowittApp": "La clé d'application, également dans votre compte Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Utilisez l'e-mail et le mot de passe de votre compte My AcuRite — pas votre identifiant SmartMixin.",
  "providerHints.myAcuriteEmail": "L'adresse e-mail de votre compte My AcuRite — pas votre identifiant SmartMixin.",
  "providerHints.myAcuritePassword": "Le mot de passe de votre compte My AcuRite.",
  "providerHints.weatherflowToken": "Jeton à usage personnel depuis tempestwx.com → paramètres → autorisations des données.",
  "providerHints.wundergroundEditKey": "Utiliser une autre clé",
  "providerHints.wundergroundKey": "Une longue chaîne issue de la page des clés API de votre compte Weather Underground — pas votre mot de passe wunderground.com.",
  "providerHints.wundergroundKeyExample": "ex. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Clé API vérifiée",
  "providerHints.wundergroundKeyVerifying": "Vérification de la clé…",
  "providerHints.wundergroundNoStationsNearby": "Aucune station trouvée près de cet emplacement. Essayez de saisir directement un identifiant de station.",
  "providerHints.wundergroundStationId": "N'importe quel identifiant de station Weather Underground — le vôtre ou celui d'une station publique près de chez vous.",
  "providerHints.wundergroundStationIdExample": "ex. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Récupérez votre clé API Ambient Weather.",
  "providerIntro.davisStep2": "Récupérez votre clé API V2 et votre secret API Davis.",
  "providerIntro.ecowittStep2": "Récupérez votre clé API et votre clé d'application Ecowitt.",
  "providerIntro.getStarted": "Commencer",
  "providerIntro.myAcuriteStep2": "Utilisez l'adresse e-mail et le mot de passe de votre compte My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Connectez-vous à Netatmo lorsque demandé — aucune clé API nécessaire.",
  "providerIntro.netatmoWeatherStep2": "Connectez-vous à Netatmo lorsque demandé — aucune clé API nécessaire.",
  "providerIntro.signupBanner": "Presque fini — créez votre compte SmartMixin gratuit pour connecter {provider}.",
  "providerIntro.step1": "Connectez-vous à votre compte SmartMixin (PAS à votre compte {provider}).",
  "providerIntro.step3EmailPassword": "Saisissez-les ici.",
  "providerIntro.step3KeyOrToken": "Collez-le ici.",
  "providerIntro.step3OAuth": "Autorisez SmartMixin dans la fenêtre qui s'ouvre.",
  "providerIntro.step3Wunderground": "Collez votre clé API, puis sélectionnez une station à proximité ou saisissez n'importe quel ID de station.",
  "providerIntro.title": "Connecter {provider}",
  "providerIntro.weatherflowStep2": "Récupérez votre jeton Tempest à usage personnel.",
  "providerIntro.wundergroundBrowsePublic": "Pas de station ? Parcourez les stations publiques",
  "providerIntro.wundergroundFindNearby": "Trouver des stations près de moi",
  "providerIntro.wundergroundOrEnterId": "Ou saisir un identifiant de station",
  "providerIntro.wundergroundStep2": "Récupérez votre clé API Weather Underground. Vous pourrez ensuite connecter n'importe quelle station — la vôtre ou une station publique.",
  "reports.agroMeteorology": "Agrométéorologie",
  "reports.analysis": "Analyses",
  "reports.annualCumulativeRainfallComparison": "Comparatif des cumuls annuels des précipitations",
  "reports.annualHeatingDurationComparison": "Comparatif annuel de la durée de chauffe",
  "reports.annualHeatingEfficiency": "Efficacité thermique annuelle",
  "reports.annualIndoorComparison": "Comparatif intérieur annuel",
  "reports.annualIndoorReport": "Rapport intérieur annuel",
  "reports.annualOutdoorComparison": "Comparatif extérieur annuel",
  "reports.annualOutdoorReport": "Rapport extérieur annuel",
  "reports.annualReport": "Rapport annuel",
  "reports.annualSolarReport": "Rapport solaire annuel",
  "reports.annualWaterBalance": "Bilan hydrique annuel",
  "reports.annualWaterBalanceCarryOver": "Reporter l'année précédente",
  "reports.annualWaterBalanceDescription": "Un bilan hydrique (version simplifiée, seulement la pluie et l'évapotranspiration sont utilisées) permet de gérer la ressource en eau",
  "reports.avgHumidity": "Humidité moyenne",
  "reports.avgMaxTemperature": "Moyenne T°max",
  "reports.avgMetric": "Moyenne – {metric}",
  "reports.avgMinTemperature": "Moyenne T°min",
  "reports.avgPressure": "Pression moyenne",
  "reports.avgTemperature": "Température moyenne",
  "reports.comfortable": "Confortable (45% {lessThan} Humidité ≤ 60%)",
  "reports.cumulativeRainfall": "Cumul des précipitations",
  "reports.cumulativeRainfallDescription": "Suivez le cumul des précipitations sur la période sélectionnée.",
  "reports.dailyMaxRainfall": "Précipitations journalières maximales",
  "reports.dataExport": "Export de données",
  "reports.dataExportXlsxFormatDescription": "Exportez toutes les données de votre station au format Excel (* .xlsx). Une fois que vous avez cliqué sur le bouton, vous recevrez un email avec les données traitées après quelques minutes.",
  "reports.daysWithFrost": "Jours avec gelées",
  "reports.daysWithoutThaw": "Jours sans dégel",
  "reports.daysWithStrongFrost": "Jours avec fortes gelées",
  "reports.emailSent": "Un email vous a été envoyé",
  "reports.grasslandTemperatureSum": "Somme des températures de prairies",
  "reports.grasslandTemperatureSumDescription": "Reprise durable de la végétation lorsque la somme atteint {threshold}",
  "reports.growingDegreeDays": "Somme des températures",
  "reports.highPressure": "Anticyclone (Pression ≥ 1013 mbar)",
  "reports.indoorReport": "Rapport intérieur",
  "reports.keyFacts": "Faits principaux",
  "reports.longestRunOfRainyDays": "Nb de jours consécutifs de pluie",
  "reports.longestRunWithoutRun": "Nb de jours consécutifs sans pluie",
  "reports.lowPressure": "Dépression (Pression < 1013 mbar)",
  "reports.maxHumidity": "Humidité maximale",
  "reports.maxMetric": "Maximum – {metric}",
  "reports.maxPressure": "Pression maximale",
  "reports.maxPressureMagnitude24h": "Amplitude maximale (/24H)",
  "reports.maxTemperature": "Température maximale",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Amplitude maximale (/24H)",
  "reports.minHumidity": "Humidité minimale",
  "reports.minMetric": "Minimum – {metric}",
  "reports.minPressure": "Pression minimale",
  "reports.minPressureMagnitude24h": "Amplitude minimale (/24H)",
  "reports.minTemperature": "Température minimale",
  "reports.minTempMagnitude24h": "Amplitude minimale (/24H)",
  "reports.monthlyHeatingEfficiency": "Efficacité thermique mensuelle",
  "reports.monthlyIndoorReport": "Rapport intérieur mensuel",
  "reports.monthlyOutdoorReport": "Rapport extérieur mensuel",
  "reports.monthlyReport": "Rapport mensuel",
  "reports.monthlySolarReport": "Rapport solaire mensuel",
  "reports.monthlyWindReport": "Rapport de vent mensuel",
  "reports.numberOfDays": "Nombre de jours",
  "reports.outdoorReport": "Rapport extérieur",
  "reports.rainfall": "Précipitations",
  "reports.rainyDays": "Jours de pluie",
  "reports.relativelyWet": "Relativement humide (60 % < Humidité ≤ 80 %)",
  "reports.sendEmail": "Envoyer un e-mail",
  "reports.tooDry": "Trop sec (Humidité ≤ 45%)",
  "reports.tooWet": "Trop humide (Humidité {greaterThan} 80%)",
  "reports.tropicalNights": "Nuits tropicales",
  "reports.waterBalance": "Bilan hydrique",
  "reports.yearToDateTemperature": "Température depuis le début de l'année",
  "reports.yearToDateTemperatureComparison": "Comparaison des températures depuis le début de l'année",
  "sensors.aqiByChannel": "AQI par canal",
  "sensors.bgtSensors": "Globe noir & WBGT",
  "sensors.cameraFeed": "Caméra",
  "sensors.compareAqi": "Comparer l'AQI",
  "sensors.compareHumidity": "Comparer l'humidité",
  "sensors.compareMoisture": "Comparer l'humidité du sol",
  "sensors.comparePm25": "Comparer les PM2.5",
  "sensors.compareTemperatures": "Comparer les températures",
  "sensors.depthByChannel": "Profondeur par canal",
  "sensors.heatStressExtreme": "Stress thermique extrême",
  "sensors.heatStressModerate": "Stress thermique modéré",
  "sensors.heatStressNone": "Pas de stress thermique",
  "sensors.heatStressStrong": "Stress thermique fort",
  "sensors.heatStressVeryStrong": "Stress thermique très fort",
  "sensors.humidityByChannel": "Humidité par canal",
  "sensors.indoorAirQuality": "Qualité de l'air intérieur",
  "sensors.indoorAirQualityPm": "PM2.5 et PM10 AQI",
  "sensors.indoorClimate": "Climat intérieur",
  "sensors.indoorCo2Levels": "Niveaux de CO2",
  "sensors.indoorTemperatureAndHumidity": "Température et humidité",
  "sensors.last24Hours": "24 heures",
  "sensors.last30Days": "30 jours",
  "sensors.last7Days": "7 jours",
  "sensors.leafTemperatureByChannel": "Température des feuilles par canal",
  "sensors.leafWetnessByChannel": "Humidité des feuilles par canal",
  "sensors.lightningSensor": "Foudre",
  "sensors.moistureByChannel": "Humidité du sol par canal",
  "sensors.noDataAvailable": "Aucune donnée disponible",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 par canal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Sélectionner le canal",
  "sensors.sensorDetailDescription": "Consultez les données historiques et les tendances de vos capteurs.",
  "sensors.sensorHistory": "Historique du capteur",
  "sensors.soilConductivityByChannel": "Conductivité par canal",
  "sensors.soilTemperatureByChannel": "Température du sol par canal",
  "sensors.strikesToday": "Impacts aujourd'hui",
  "sensors.temperatureByChannel": "Température par canal",
  "sensors.viewChart": "Voir le graphique",
  "settings.about": "À propos",
  "settings.aboutDescription": "Contrat de licence, politique de confidentialité",
  "settings.account": "Profil et Sécurité",
  "settings.accountDescription": "Nom, mot de passe, suppression du compte",
  "settings.accountIntro": "Les données concernent votre compte :",
  "settings.accountSection": "Compte",
  "settings.appearance": "Apparence",
  "settings.appearanceDescription": "Thème et options d'affichage",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "arabe",
  "settings.availableServices": "Disponible",
  "settings.bulgarian": "bulgare",
  "settings.cannotDisconnectLastAccount": "Impossible de déconnecter votre seule méthode de connexion. Veuillez d'abord ajouter une autre méthode de connexion.",
  "settings.catalan": "catalan",
  "settings.changeEmail": "Changer d'e-mail",
  "settings.changePassword": "Changer de mot de passe",
  "settings.chartGestures": "Gestes sur les graphiques",
  "settings.chartGesturesDescription": "Faire glisser le doigt sur les graphiques change la période, le pincement des graphiques change l'échelle de temps",
  "settings.connect": "Connecter",
  "settings.connected": "Connecté",
  "settings.connectedAccounts": "Comptes connectés",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Connecté",
  "settings.connectedSince": "Connecté depuis le {date}",
  "settings.connectionSuccess": "Compte {provider} connecté avec succès",
  "settings.contactUs": "Nous contacter",
  "settings.contactUsDescription": "Obtenir de l'aide ou envoyer des commentaires",
  "settings.croatian": "croate",
  "settings.currentPassword": "Mot de passe actuel",
  "settings.czech": "tchèque",
  "settings.danish": "danois",
  "settings.dark": "Thème sombre",
  "settings.dataDisplay": "Affichage des données",
  "settings.dateAndTime": "Date et heure",
  "settings.disconnect": "Déconnecter",
  "settings.disconnectConfirmation": "Êtes-vous sûr de vouloir déconnecter votre compte {provider} ?",
  "settings.disconnectionSuccess": "Compte {provider} déconnecté avec succès",
  "settings.donateButton": "Faire un don",
  "settings.donateDescription": "SmartMixin est développé par une petite équipe. Si l'application vous est utile, vous pouvez soutenir son développement avec un don unique du montant de votre choix. C'est un cadeau — cela ne change pas votre formule et ne débloque aucune fonctionnalité.",
  "settings.donateSuccessBody": "Votre don aide à faire fonctionner SmartMixin et à l'améliorer. Nous vous en sommes très reconnaissants.",
  "settings.donateSuccessTitle": "Merci pour votre soutien !",
  "settings.donateTitle": "Soutenir SmartMixin",
  "settings.dutch": "néerlandais",
  "settings.emailChange": "Changer d'adresse e-mail",
  "settings.emailChangeConfirmation": "Confirmation du changement d'e-mail",
  "settings.emailChangeFailure": "Le lien de changement d'e-mail est invalide ou a expiré.",
  "settings.emailChangeSuccess": "Votre e-mail a été changé avec succès pour {newEmail}.",
  "settings.emailChangeVerificationSent": "Un e-mail de vérification a été envoyé à votre nouvelle adresse e-mail. Veuillez vérifier votre boîte de réception et cliquer sur le lien pour confirmer le changement.",
  "settings.english": "anglais",
  "settings.forecastModelOrderEmpty": "Aucun ordre enregistré — nous utilisons GFS par défaut.",
  "settings.forecastModelOrderFreeHint": "Les modèles premium nécessitent un abonnement SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Nous choisissons le premier modèle de votre liste qui couvre chaque station.",
  "settings.forecastModelOrderReset": "Réinitialiser",
  "settings.forecastModelOrderTitle": "Modèle de prévision par défaut",
  "settings.forecastModels": "Modèles de prévision",
  "settings.forecastModelsDescription": "Réordonner selon vos préférences",
  "settings.french": "français",
  "settings.german": "allemand",
  "settings.gestures": "Gestes",
  "settings.greek": "grec",
  "settings.helpCenter": "Centre d'aide",
  "settings.helpCenterDescription": "FAQ et guides",
  "settings.hungarian": "hongrois",
  "settings.integrationsSection": "Intégrations",
  "settings.italian": "italien",
  "settings.japanese": "japonais",
  "settings.korean": "coréen",
  "settings.language": "Langue",
  "settings.languageDescription": "Langue préférée",
  "settings.light": "Thème clair",
  "settings.newEmailAddress": "Nouvelle adresse e-mail",
  "settings.newPassword": "Nouveau mot de passe",
  "settings.newPasswordAgain": "Confirmer le nouveau mot de passe",
  "settings.norwegian": "norvégien",
  "settings.notConnected": "Non connecté",
  "settings.notificationsSection": "Notifications",
  "settings.oldPassword": "Ancien mot de passe",
  "settings.ongoingNotificationEnabled": "Activer la notification permanente",
  "settings.ongoingNotificationMetrics": "Métriques affichées",
  "settings.ongoingNotificationMetricsHint": "Faites glisser pour réorganiser les métriques sélectionnées",
  "settings.ongoingNotificationPermissionRequired": "L'autorisation de notification est requise",
  "settings.ongoingNotificationStation": "Station météo",
  "settings.passwordChange": "Changement de mot de passe",
  "settings.polish": "polonais",
  "settings.portuguese": "portugais",
  "settings.preferencesSection": "Préférences",
  "settings.premium": "SmartMixin Premium",
  "settings.premiumActive": "Actif",
  "settings.premiumAnnualThenPrice": "Puis 9,99 €/an",
  "settings.premiumAnnualTrialInfo": "Commencez avec un essai gratuit de {days} jours",
  "settings.premiumCurrentPlan": "Abonnement actuel",
  "settings.premiumDescription": "Gérer votre abonnement",
  "settings.premiumDownloadApp": "Téléchargez l'application pour vous abonner :",
  "settings.premiumExpiresOn": "Renouvellement le {date}",
  "settings.premiumFreePlan": "Gratuit",
  "settings.premiumInactive": "Non abonné",
  "settings.premiumManageWebSubscription": "Gérer votre abonnement, mettre à jour le moyen de paiement ou annuler.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Annuel — 9,99 €/an",
  "settings.premiumSubscribedOn": "Abonné sur {platform}",
  "settings.premiumSubscribeMonthly": "Mensuel — 1,99 €/mois",
  "settings.premiumSubscribeOnWeb": "Abonnez-vous maintenant pour débloquer toutes les fonctionnalités Premium.",
  "settings.premiumSubscriptionSuccess": "Votre abonnement a été activé ! Profitez de toutes les fonctionnalités Premium.",
  "settings.premiumSubscriptionSuccessTitle": "Bienvenue dans Premium !",
  "settings.premiumWebappNotice": "Les abonnements ne peuvent être souscrits que via l'application mobile SmartMixin sur iOS ou Android.",
  "settings.privacyPolicy": "Politique de confidentialité",
  "settings.profile": "Profil",
  "settings.russian": "russe",
  "settings.serbian": "serbe",
  "settings.settings": "Configuration",
  "settings.slovak": "slovaque",
  "settings.smallDecimals": "Petites décimales",
  "settings.smallDecimalsDescription": "Afficher les chiffres décimaux dans une taille plus petite",
  "settings.socialConnectionsIntro": "Liez vos comptes sociaux pour une connexion rapide. Vous pouvez connecter ou déconnecter des comptes à tout moment.",
  "settings.spanish": "espagnol",
  "settings.statusBarWidget": "Widget barre d'état",
  "settings.statusBarWidgetDescription": "Données météo toujours visibles",
  "settings.subscriptionSection": "Abonnement",
  "settings.supportSection": "Support",
  "settings.swedish": "suédois",
  "settings.systemTheme": "Thème système",
  "settings.termsOfService": "Conditions d'utilisation",
  "settings.turkish": "turc",
  "settings.ukrainian": "ukrainien",
  "settings.units": "Unités",
  "settings.unitsDescription": "Unités de mesure affichées dans l'application",
  "settings.update": "Mettre à jour",
  "settings.updateYourProfile": "Mettez à jour votre profil",
  "settings.weatherServices": "Services météo",
  "settings.weatherServicesConnected": "{count, plural, =0 {Aucun service connecté} one {# service connecté} other {# services connectés}}",
  "settings.weatherServicesDescription": "Connectez Netatmo, Davis, Weatherflow, et plus",
  "settings.windDirectionConvention": "Flèche de direction du vent",
  "settings.windDirectionConventionDescription": "Choisir comment les flèches de direction du vent sont affichées",
  "settings.windDirectionMeteorological": "Direction d'origine",
  "settings.windDirectionMeteorologicalDescription": "La flèche indique d'où vient le vent (convention météorologique)",
  "settings.windDirectionOceanographic": "Direction du flux",
  "settings.windDirectionOceanographicDescription": "La flèche indique où le vent souffle (convention océanographique)",
  "units.absolutePressure": "Pression absolue",
  "units.airDensity": "Densité de l'air",
  "units.airGap": "Espace d'air",
  "units.apparentTemperature": "Température apparente",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Moy.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Temp. globe noir",
  "units.boilerOn": "Chaudière en marche",
  "units.co2": "CO2",
  "units.conductivity": "Conductivité",
  "units.coolingDegreeDays": "Degrés-jours de refroidissement",
  "units.dailyHeatingDuration": "Durée de chauffe journalière",
  "units.dailyPrecipitation": "Précipitations journalières",
  "units.dailyRain": "Pluie du jour",
  "units.degreeDay": "Degré-jour",
  "units.degreeDayShort": "DJU",
  "units.depth": "Profondeur",
  "units.depthSensors": "Capteurs de profondeur",
  "units.dewPoint": "Point de rosée",
  "units.distance": "Distance",
  "units.downTrend": "Tendance à la baisse",
  "units.E": "E",
  "units.E_long": "est",
  "units.ENE": "ENE",
  "units.ENE_long": "est-nord-est",
  "units.ESE": "ESE",
  "units.ESE_long": "est-sud-est",
  "units.ET": "Evapotranspiration",
  "units.ETshort": "ET",
  "units.feelLike": "Ressenti",
  "units.feelsLike": "Ressenti",
  "units.footMile": "Pied, mile",
  "units.frostPoint": "Point de gel",
  "units.gust": "Rafale",
  "units.heatIndex": "Indice de chaleur",
  "units.heatingDegreeDays": "Degrés-jours de chauffage",
  "units.heatingPower": "Puissance de chauffage",
  "units.humidex": "Humidex",
  "units.humidity": "Humidité",
  "units.inch": "Pouce",
  "units.inchOfMercury": "Pouce de mercure",
  "units.kilometerPerHour": "Kilomètre par heure",
  "units.knot": "Noeud",
  "units.last12Hours": "12 dernières heures",
  "units.last24Hours": "24 dernières heures",
  "units.last3Hours": "3 dernières heures",
  "units.last6Hours": "6 dernières heures",
  "units.lastHour": "Dernière heure",
  "units.lastLightningImpact": "Dernier impact de foudre",
  "units.lastMeasure": "Dernière mesure",
  "units.leafSensors": "Capteurs d'humectation",
  "units.leafWetness": "Humectation foliaire",
  "units.lightningDistance": "Distance",
  "units.lightningStrikeCount": "Nombre d'impacts de foudre",
  "units.lightningStrikeDistance": "Distance de l'impact de foudre",
  "units.max": "Max.",
  "units.max_gust": "Rafale max.",
  "units.max_wind": "Vent max.",
  "units.meterKilometer": "Mètre, kilomètre",
  "units.meterPerSecond": "Mètre par seconde",
  "units.milePerHour": "Mile par heure",
  "units.millibar": "Millibar",
  "units.millimeter": "Millimètre",
  "units.millimeterOfMercury": "Millimètre de mercure",
  "units.min": "Min.",
  "units.N": "N",
  "units.N_long": "nord",
  "units.NE": "NE",
  "units.NE_long": "nord-est",
  "units.NNE": "NNE",
  "units.NNE_long": "nord-nord-est",
  "units.NNW": "NNO",
  "units.NNW_long": "nord-nord-ouest",
  "units.noise": "Bruit",
  "units.normalizedHeatingCoefficient": "Coefficient de chauffage normalisé",
  "units.NW": "NO",
  "units.NW_long": "nord-ouest",
  "units.O3": "Ozone",
  "units.PM_1": "PM 1",
  "units.PM_10": "PM 10",
  "units.PM_2P5": "PM 2,5",
  "units.precipitation": "Précipitations",
  "units.pressure": "Pression",
  "units.rain": "Pluie",
  "units.rainRate": "Intensité de pluie",
  "units.referenceTemperature": "Température de référence",
  "units.relativePressure": "Pression relative",
  "units.S": "S",
  "units.S_long": "sud",
  "units.SE": "SE",
  "units.SE_long": "sud-est",
  "units.setPoint": "Consigne",
  "units.snow": "Neige",
  "units.snowfall": "Chute de neige",
  "units.soilMoisture": "Humidité du sol",
  "units.soilSensors": "Capteurs de sol",
  "units.solarEnergy": "Énergie solaire",
  "units.solarRadiation": "Rayonnement solaire",
  "units.speed": "Vitesse",
  "units.SSE": "SSE",
  "units.SSE_long": "sud-sud-est",
  "units.SSW": "SSO",
  "units.SSW_long": "sud-sud-ouest",
  "units.stableTrend": "Tendance stable",
  "units.sum": "Cumul",
  "units.SW": "SO",
  "units.SW_long": "sud-ouest",
  "units.temperature": "Température",
  "units.temperatureAndHumiditySensors": "Capteurs de température/humidité",
  "units.temperatureSensors": "Capteurs de température/humidité",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Aujourd'hui",
  "units.upTrend": "Tendance à la hausse",
  "units.uv": "UV",
  "units.visibility": "Visibilité",
  "units.W": "O",
  "units.W_long": "ouest",
  "units.wetBulbGlobeTemperature": "Temp. thermomètre-globe mouillé",
  "units.wetBulbTemperature": "Temp. bulbe humide",
  "units.wind": "Vent",
  "units.windChill": "Refroidissement éolien",
  "units.windDirection": "Direction du vent",
  "units.windRun": "Parcours du vent",
  "units.windRunDescription": "Le parcours du vent est la distance totale parcourue par le vent sur une période de temps",
  "units.WNW": "ONO",
  "units.WNW_long": "ouest-nord-ouest",
  "units.WSW": "OSO",
  "units.WSW_long": "ouest-sud-ouest"
}
